/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Application {
  /**
   * Id
   * Идентификатор запроса
   * @format uuid
   */
  id: string;

  /**
   * Createdate
   * Дата подачи заявления
   * @format date
   */
  createDate?: string;

  /**
   * Ausnstartdate
   * Дата перехода на АУСН
   */
  ausnStartDate?: number;

  /**
   * Statuscode
   * Статус заявления
   */
  statusCode: string;

  /**
   * Parentappid
   * Идентификатор заявки на отмену
   * @format uuid
   */
  parentAppId?: string;

  /**
   * Fnserrors
   * Ошибка ФНС
   */
  fnsErrors?: FnsError[];
}

export interface ApplicationInfo {
  /** Typecode */
  typeCode: number;
  IPInformation?: IPInformation;
  contactPerson?: ContactPerson;

  /** Expectedregisterdate */
  expectedRegisterDate?: number;

  /** Taxobject */
  taxObject?: number;

  /** Rejectothertaxregime */
  rejectOtherTaxRegime?: number;

  /** Refuseothertaxregime */
  refuseOtherTaxRegime?: number;

  /** Permissiongroup */
  permissionGroup?: string;

  /** Taxobjectdateupdate */
  taxObjectDateUpdate?: number;

  /** Reason */
  reason?: string;

  /**
   * Violationunregistrationdate
   * @format date
   */
  violationUnregistrationDate?: string;

  /** Violationcodes */
  violationCodes?: string;

  /** Usnregister */
  usnRegister?: number;

  /** Usnrequisitesdate */
  usnRequisitesDate?: number;

  /** Usnrequisitestaxobject */
  usnRequisitesTaxObject?: number;

  /** Eshnregister */
  eshnRegister?: number;

  /** Eshnrequisitesdate */
  eshnRequisitesDate?: number;

  /** Parentappid */
  parentAppId?: string;
}

export interface AusnPreliminaryTax {
  /**
   * Id
   * Идентификатор
   * @format uuid
   */
  id: string;

  /**
   * Year
   * Год расчета налога
   */
  year: number;

  /**
   * Month
   * Месяц расчета налога
   */
  month: number;

  /**
   * Amount
   * Сумма предварительного налога
   */
  amount?: number;

  /**
   * Updatetime
   * Время обновления
   * @format date-time
   */
  updateTime?: string;
}

export interface AusnTax {
  /**
   * Id
   * Идентификатор начисления налога АУСН в ПП АУСН
   * @format uuid
   */
  id: string;

  /**
   * Status
   * Статус
   */
  status?: string;

  /**
   * Year
   * Показатель налогового периода – год
   */
  year: number;

  /**
   * Month
   * Показатель налогового периода – месяц
   */
  month: number;

  /**
   * Duedate
   * Срок оплаты
   * @format date
   */
  dueDate?: string;

  /**
   * Amount
   * Сумма начисления
   */
  amount: number;

  /**
   * Paidsum
   * Уплаченная сумма (зачтено по начислению)
   */
  paidSum?: number;

  /**
   * Updatetime
   * Дата последнего обновления данных
   * @format date-time
   */
  updateTime?: string;
}

export interface ClientInfo {
  /**
   * Inn
   * ИНН
   */
  inn: string;

  /**
   * Shortname
   * Краткое имя
   */
  shortName?: string;

  /**
   * Regdate
   * Дата регистрации ЮЛ
   * @format date
   */
  regDate?: string;

  /**
   * Taxobject
   * Объект налогообложения
   */
  taxObject?: number;

  /**
   * Permission
   * Права банка
   */
  permission?: string;

  /**
   * Authoritysignature
   * Право подписи
   */
  authoritySignature?: boolean;

  /**
   * Begindateausn
   * Дата постановки клиентана АУСН
   */
  beginDateAusn?: string;

  /**
   * Enddateausn
   * Дата окончания нахождения клиента АУСН
   */
  endDateAusn?: string;
}

export interface Deductions {
  /** Code */
  code: string;

  /** Amount */
  amount: string;
}

export interface DefaultResponse {
  /** Status */
  status?: string;
  error?: Error;
}

/**
 * @example {"id":"422d05c3-2008-4dc6-b64c-7601ed193f06","companyInn":"291289217108","employees":[{"employeeInn":"355120569990","employeeName":"Ляшко Евгений Валерьевич","employeeLastName":"Ляшко","employeeFirstName":"Евгений","employeePatronymic":"Валерьевич","snils":"059-798-727 52","salary":"60000.0","birthday":"14.10.1985","employment":"05.07.2022","dismissal":"","typeofemployment":"0","position":"Работник","division":"Тут","gender":"1","employeetype":"1","citizenship":"643","phone":"325-213-53-23","email":"fdhgh@gh.ru","manager":"Руководитель","birthplace":"Уфа","residenceAddress":"Уфа","comment":"","fine":false,"aliments":false,"bailiffs":false,"other":false,"employeeAccounts":[{"employeeBankBik":"044525187","employeeBankCountry":"","employeeBankName":"БАНК ВТБ (ПАО)","employeeAccountCurrency":"RUR","employeeAccountNumber":"40817810346712394176","employeeBankCorrespondentAccount":""}],"employeeDocuments":[{"documentType":"21 - Паспорт гражданина Российской Федерации","documentTypeMvd":"21","documentSeries":"234-324","documentNumber":"43543234","documentDateOfIssue":"17.10.2012","documentValidityPeriod":"","documentIssuedByWhom":"УФЬС","documentDivisionCode":"454-242","documentLastNameEng":"","documentFirstNameEng":"","documentCountry":"643","documentIsAnIdentityDocument":"True"}]}]}
 */
export interface EmployeesParser {
  /** Id */
  id: string;

  /** Companyinn */
  companyInn: string;

  /** Employees */
  employees: EmployeeSts[];
}

export interface EnsBalance {
  /**
   * Amount
   * Сальдо ЕНС
   */
  amount?: number;

  /**
   * Updatetime
   * Дата последнего обновления
   * @format date-time
   */
  updateTime?: string;
}

export interface EnsRequisites {
  /**
   * Documenttype
   * Тип документа
   */
  documentType?: string;

  /**
   * Amount
   * Сальдо ЕНС
   */
  amount?: string;

  /**
   * Payerinn
   * ИНН плательщика
   */
  payerInn?: string;

  /**
   * Payerkpp
   * КПП плательщика
   */
  payerKpp?: string;

  /**
   * Taxpayerstatus
   * Информация, идентифицирующая плательщика средств, получателя средств и платеж (Статус плательщика)
   */
  taxPayerStatus?: string;

  /**
   * Receiverinn
   * ИНН получателя
   */
  receiverInn?: string;

  /**
   * Receiverkpp
   * КПП получателя
   */
  receiverKpp?: string;

  /**
   * Receiverbankname
   * Наименование банка получателя средств
   */
  receiverBankName?: string;

  /**
   * Receiverbankbic
   * БИК банка получателя средств (БИК ТОФК)
   */
  receiverBankBIC?: string;

  /**
   * Receiverbankcoraccount
   * № счета банка получателя средств (номер банковского счета, входящего в состав единого казначейского счета)
   */
  receiverBankCorAccount?: string;

  /**
   * Receivername
   * Получатель
   */
  receiverName?: string;

  /**
   * Receiveraccount
   * Номер казначейского счёта
   */
  receiverAccount?: string;

  /**
   * Uip
   * Код(УИП)
   */
  uip?: string;

  /**
   * Purpose
   * Назначение платежа
   */
  purpose?: string;

  /**
   * Kbk
   * КБК
   */
  kbk?: string;

  /**
   * Oktmo
   * ОКТМО
   */
  oktmo?: string;

  /**
   * Taxpaymentpurpose
   * Основание платежа
   */
  taxPaymentPurpose?: string;

  /**
   * Taxpaymentperiod
   * Налоговый период
   */
  taxPaymentPeriod?: string;

  /**
   * Taxpaymentdocumentnumber
   * Номер документа основания платежа
   */
  taxPaymentDocumentNumber?: string;

  /**
   * Taxpaymentdocumentdate
   * Дата документа основания платежа
   */
  taxPaymentDocumentDate?: string;
}

export interface Error {
  /**
   * Code
   * Код ошибки
   */
  code: number;

  /**
   * Description
   * Описание ошибки
   */
  description: string;
}

export interface FnsError {
  /** Id */
  id?: string;

  /** Description */
  description?: string;
}

export interface GetCodes {
  /**
   * Payments
   * Сведения о выплатах
   */
  payments?: Payment[];

  /**
   * Deductions
   * Сведения о вычетах
   */
  deductions?: Deduction[];

  /** Uninsuredpayments */
  uninsuredPayments: UninsuredPaymentsItem[];
}

export interface GetCountries {
  /**
   * Citizenship
   * Гражданство
   */
  citizenship: string;

  /**
   * Name
   * Название страны
   */
  name: string;

  /**
   * Countrycode
   * Код страны
   */
  countryCode: string;
}

export interface GetEmployees {
  /**
   * Id
   * Уникальный идентификатор, генерируемый Банком для налогоплательщика
   */
  id: string;

  /**
   * Companyogrn
   * ОГРН/ОГРНИП
   */
  companyOgrn?: string;

  /**
   * Companyname
   * Для ЮЛ - Наименование налогоплательщика / Для ИП - ФИО налогоплательщика
   */
  companyName?: string;

  /**
   * Companyinn
   * ИНН налогоплательщика
   */
  companyInn: string;

  /**
   * Companykpp
   * КПП налогоплательщика(для ЮЛ)
   */
  companyKpp?: string;

  /**
   * Statusfree
   * Клиент на бесплатном тарифе
   */
  statusFree?: boolean;

  /**
   * Employees
   * Сведения по сотруднику/ам
   */
  employees?: Employ[];
}

export interface GetMovementsArchive {
  /**
   * Id
   * ИД пакета, который лежит в модуле Сотрудники
   */
  id: string;

  /**
   * Companyogrn
   * ОГРН/ОГРНИП
   */
  companyOgrn?: string;

  /**
   * Companyname
   * Для ЮЛ - Наименование налогоплательщика / Для ИП - ФИО налогоплательщика
   */
  companyName?: string;

  /**
   * Companyinn
   * ИНН налогоплательщика
   */
  companyInn: string;

  /**
   * Companykpp
   * КПП налогоплательщика(для ЮЛ)
   */
  companyKpp?: string;

  /**
   * Statusfree
   * Клиент на бесплатном тарифе
   */
  statusFree?: boolean;

  /**
   * Calculations
   * Выплаты
   */
  calculations?: Calculation[];
}

export interface GetOperationsRequest {
  /** Accountnumber */
  accountNumber?: string;

  /**
   * Startdate
   * @format date
   */
  startDate: string;

  /**
   * Enddate
   * @format date
   */
  endDate: string;
  orderBy?: OrderBy;
  pagination: Pagination;
}

export interface GetOperationsResponse {
  /** Account Number */
  accountNumber?: string;

  /**
   * Startdate
   * @format date
   */
  startDate: string;

  /**
   * Enddate
   * @format date
   */
  endDate: string;

  /** Operations */
  operations?: Operation[];
  orderBy?: OrderBy;
  pagination?: PaginationInResponse;
  error?: Error;
}

export interface GetTaxesResponse {
  statusCode?: TaxesStatusCode;
  clientInfo?: ClientInfo;

  /** Applications */
  applications?: Application[];
  taxCharges?: TaxCharges;
  error?: Error;
}

export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

export interface IPInformation {
  /** Iplastname */
  IPLastName?: string;

  /** Ipfirstname */
  IPFirstName?: string;

  /** Ippatronymic */
  IPPatronymic?: string;
}

export interface Markup {
  /** Tax Base Code */
  taxBaseCode?: number;

  /** Operation Category Code */
  operationCategoryCode?: number;

  /** Foreign Currency Amount */
  amount?: number;
}

export interface MarkupOperationRequest {
  /** Id */
  id: string;

  /** Fnsprocessingstatecode */
  fnsProcessingStateCode: number;

  /** Markupmodecode */
  markupModeCode: number;

  /** Markups */
  markups: Markups[];
}

export interface Markups {
  /**
   * Amount
   * Сумма в рублях
   */
  amount: number;

  /**
   * Taxbasecode
   * Код признака отнесения операции к налоговой базе
   */
  taxBaseCode: number;

  /**
   * Operationcategorycode
   * Код категории операции
   */
  operationCategoryCode?: number;
}

/**
 * @example {"id":"ae4faa3c-a335-4b64-a11e-ab4dd33b8997","companyInn":"471900099999","preliminarily":"True","calculations":[{"id":"5555559999991","snils":"018-609-999 99","lastModifiedDate":"","paymentCalculationMonth":"2","paymentCalculationYear":"2022","paymentCode":"2000","bankOperationId":"","paymentAmount":"9000","retentionAmount":"","calculatedTaxAmount":"2000","withholdTaxAmount":"2000","paidTaxAmount":"2000","paymentDate":"22.05.2022 7:00:03","status":"","deductions":[{"code":"126","amount":"1400"}],"uninsuredPayments":[]}]}
 */
export interface Movements {
  /**
   * Id
   * Уникальный идентификатор документа
   */
  id: string;

  /**
   * Companyinn
   * ИНН налогоплательщика
   */
  companyInn: string;

  /**
   * Preliminarily
   * Документ новый
   */
  preliminarily?: string;

  /** Calculations */
  calculations: Calculations[];
}

export interface Notification {
  /** Inn */
  inn?: string;

  /** Hasmore */
  hasMore?: boolean;

  /** Notifications */
  notifications?: FnsNotification[];
  error?: Error;
}

export interface NotificationStatus {
  /**
   * Messageid
   * Идентификатор сообщения в рамках одного налогоплательщика
   */
  messageId: string;

  /**
   * Notificationstatus
   * Статус оповещения
   */
  notificationStatus: string;
}

export interface OSSRequisites {
  /**
   * Documenttype
   * Код документа
   */
  documentType: string;

  /**
   * Amount
   * Сумма
   */
  amount?: number;

  /**
   * Purpose
   * Назначение платежа
   */
  purpose: string;

  /**
   * Payerinn
   * ИНН плательщика
   */
  payerInn: string;

  /**
   * Payerkpp
   * КПП плательщика
   */
  payerKpp?: string;

  /**
   * Receiverinn
   * ИНН получателя
   */
  receiverInn: string;

  /**
   * Receiverkpp
   * КПП получателя
   */
  receiverKpp?: string;

  /**
   * Receiveraccount
   * Номер счёта получателя
   */
  receiverAccount: string;

  /**
   * Receivername
   * Получатель
   */
  receiverName: string;

  /**
   * Receiverbankbic
   * БИК банка получателя
   */
  receiverBankBIC: string;

  /**
   * Receiverbankcoraccount
   * Корреспондентский счёт банка получателя
   */
  receiverBankCorAccount: string;

  /**
   * Receiverbankname
   * Наименование банка получателя средств
   */
  receiverBankName: string;

  /**
   * Taxpayerstatus
   * Информация по налогоплательщику
   */
  taxPayerStatus: string;

  /**
   * Kbk
   * Показатель кода бюджетной классификации
   */
  kbk: string;

  /**
   * Oktmo
   * Код ОКТМО территории, на которой мобилизуются денежные средства от уплаты налога, сбора и иного платежа
   */
  oktmo: string;

  /**
   * Taxpaymentpurpose
   * Основание платежа
   */
  taxPaymentPurpose: string;

  /**
   * Taxpaymentperiod
   * Показатель налогового периода
   */
  taxPaymentPeriod: string;

  /**
   * Taxpaymentdocumentnumber
   * Номер документа
   */
  taxPaymentDocumentNumber: string;

  /**
   * Taxpaymentdocumentdate
   * Дата документа
   */
  taxPaymentDocumentDate: string;

  /**
   * Uip
   * Код(УИП)
   */
  uip: string;
}

export interface Offer {
  /** Status */
  status: string;
}

export interface Operation {
  /**
   * Id
   * Идентификатор операции
   */
  id: string;

  /**
   * Account Number
   * Расчетный счет организации
   */
  accountNumber?: string;

  /**
   * Is Debited
   * Признак дебетования
   */
  isDebited?: boolean;

  /**
   * Markup Mode Code
   * Признак, указывающий на то, кто выполнил разметку операции
   */
  markupModeCode?: number;

  /**
   * Fns Processing State Code
   * Состояние отправки в ФНС
   */
  fnsProcessingStateCode?: number;

  /**
   * Currency Code
   * Валюта операции
   */
  currencyCode?: string;

  /**
   * Foreign Currency Amount
   * Сумма операции
   */
  amount?: number;

  /**
   * Counterparty Name
   * Наименование контрагента
   */
  counterpartyName?: string;

  /**
   * Payment Purpose
   * Назначение платежа
   */
  purpose?: string;

  /**
   * Draw Date
   * Дата и время совершения операции
   * @format date
   */
  date?: string;

  /**
   * Doc Number
   * Номер документа
   */
  docNumber?: string;

  /**
   * Markups
   * Разметки транзакции
   */
  markups: Markup[];
}

export interface OrderBy {
  /** Sortfield */
  sortField: string;

  /** Direction */
  direction: string;
}

export interface OssAmount {
  /** Year */
  year: number;

  /** Ossamount */
  ossAmount: number;
}

export interface Pagination {
  /**
   * Pagenumber
   * Номер страницы
   */
  pageNumber: number;

  /**
   * Rowcount
   * Количество записей на странице в запросе
   */
  rowCount: number;
}

export interface PaginationInResponse {
  /**
   * Pagenumber
   * Номер страницы
   */
  pageNumber: number;

  /**
   * Rowcount
   * Количество записей на странице в запросе
   */
  rowCount: number;

  /**
   * Hasnextpage
   * Признак наличия следующей страницы
   */
  hasNextPage: boolean;
}

export interface SendApplication {
  applicationInfo: ApplicationInfo;
}

export interface TaxCharges {
  tax?: AusnTax;
  preliminaryTax?: AusnPreliminaryTax;
  ensBalance: EnsBalance;
  requisites?: EnsRequisites;
}

export interface TaxesStatusCode {
  /** Code */
  code: number;

  /** Description */
  description?: string;
}

export interface ValidationError {
  /** Location */
  loc: (string | number)[];

  /** Message */
  msg: string;

  /** Error Type */
  type: string;
}

export interface Applications {
  /**
   * Id
   * Идентификтор заявления
   */
  id: string;

  /**
   * Status
   * Статус заявления
   */
  status: string;

  /**
   * Createdate
   * Дата подачи заявления
   * @format date-time
   */
  createDate: string;

  /**
   * Type
   * Тип заявления
   */
  type: string;

  /**
   * Datechanged
   * Дата, с которой действует заявление
   */
  dateChanged?: string;

  /**
   * Parentappid
   * Идентификатор родительского заявления
   */
  parentAppId?: string;

  /**
   * Fnserrors
   * Причина отказа ФНС
   */
  fnsErrors?: FnsError;
}

export interface ApplicationsGet {
  /** Applications */
  applications?: Applications[];
  error?: Error;
}

export interface AusnSettings {
  /**
   * Isausnactive
   * Статус применения АУСН в данный момент
   */
  isAusnActive?: string;

  /**
   * Taxobject
   * Объект налогообложения
   */
  taxObject?: number;

  /**
   * Updatetime
   * Дата и время обновления данных о настройках
   * @format date-time
   */
  updateTime?: string;

  /**
   * Permission
   * Права банка
   */
  permission?: string;

  /**
   * Contactpersonlastname
   * Фамилия контактного лица
   */
  contactPersonLastName?: string;

  /**
   * Contactpersonfirstname
   * Имя контактного лица
   */
  contactPersonFirstName?: string;

  /**
   * Contactpersonpatronymic
   * Отчество контактного лица
   */
  contactPersonPatronymic?: string;

  /**
   * Contactpersonphone
   * Телефон контактного лица
   */
  contactPersonPhone?: string;

  /**
   * Contactpersonemail
   * Электронная почта контактного лица
   */
  contactPersonEmail?: string;
  error?: Error;
}

export interface Calculation {
  /** Id */
  id: string;

  /** Employeename */
  employeeName?: string;

  /** Employeekod */
  employeeKod?: string;

  /** Employeeinn */
  employeeInn?: string;

  /** Snils */
  snils: string;

  /** Lastmodifieddate */
  lastModifiedDate: string;

  /** Paymentcalculationmonth */
  paymentCalculationMonth: number;

  /** Paymentcalculationyear */
  paymentCalculationYear: number;

  /** Paymentcode */
  paymentCode: string;

  /** Documentid */
  documentId?: string;

  /** Bankoperationid */
  bankOperationId?: string;

  /** Paymentamount */
  paymentAmount?: number;

  /** Calculatedtaxamount */
  calculatedTaxAmount?: number;

  /** Withholdtaxamount */
  withholdTaxAmount?: number;

  /** Paidtaxamount */
  paidTaxAmount?: number;

  /** Paymentdate */
  paymentDate?: string;

  /** Status */
  status?: string;

  /** Deductions */
  deductions: Deduct[];

  /** Uninsuredpayments */
  uninsuredPayments: Uninsured[];

  /** Retentionamount */
  retentionAmount?: number;
}

export interface Calculations {
  /** Id */
  id: string;

  /** Snils */
  snils: string;

  /** Lastmodifieddate */
  lastModifiedDate: string;

  /** Paymentcalculationmonth */
  paymentCalculationMonth: string;

  /** Paymentcalculationyear */
  paymentCalculationYear: string;

  /** Paymentcode */
  paymentCode: string;

  /** Bankoperationid */
  bankOperationId?: string;

  /** Paymentamount */
  paymentAmount: string;

  /** Retentionamount */
  retentionAmount: string;

  /** Calculatedtaxamount */
  calculatedTaxAmount: string;

  /** Withholdtaxamount */
  withholdTaxAmount: string;

  /** Paidtaxamount */
  paidTaxAmount: string;

  /** Paymentdate */
  paymentDate: string;

  /** Status */
  status?: string;

  /** Deductions */
  deductions?: Deductions[];

  /** Uninsuredpayments */
  uninsuredPayments?: UninsuredPayment[];
}

export interface ContactPerson {
  /** Contactpersonlastname */
  contactPersonLastName?: string;

  /** Contactpersonfirstname */
  contactPersonFirstName?: string;

  /** Contactpersonpatronymic */
  contactPersonPatronymic?: string;

  /** Contactpersonphone */
  contactPersonPhone?: string;

  /** Contactpersonemail */
  contactPersonEmail?: string;
}

export interface Deduct {
  /** Code */
  code?: string;

  /** Amount */
  amount?: string;
}

export interface Deduction {
  /** Code */
  code?: string;

  /** Name */
  name?: string;

  /** Recommendedamount */
  recommendedAmount?: string;
}

export interface Employ {
  /** Employeekod */
  employeeKod?: string;

  /** Employeeinn */
  employeeInn?: string;

  /** Employeename */
  employeeName?: string;

  /** Employeelastname */
  employeeLastName: string;

  /** Employeefirstname */
  employeeFirstName?: string;

  /** Employeepatronymic */
  employeePatronymic?: string;

  /** Salary */
  salary?: number;

  /** Snils */
  snils: string;

  /** Birthday */
  birthday: string;

  /** Dismissal */
  dismissal?: string;

  /** Typeofemployment */
  typeOfEmployment?: number;

  /** Position */
  position?: string;

  /** Division */
  division?: string;

  /** Gender */
  gender?: number;

  /** Employeetype */
  employeeType?: number;

  /** Citizenship */
  citizenship?: string;

  /** Phone */
  phone?: string;

  /** Email */
  email?: string;

  /** Manager */
  manager?: string;

  /** Birthplace */
  birthplace?: string;

  /** Residenceaddress */
  residenceAddress?: string;

  /** Contractnumber */
  contractNumber?: string;

  /** Comment */
  comment?: string;

  /** Fine */
  fine?: boolean;

  /** Aliments */
  aliments?: boolean;

  /**
   * Bailiffs
   * Судебные приставы
   */
  bailiffs?: boolean;

  /** Other */
  other?: boolean;

  /** Employeeaccounts */
  employeeAccounts: EmployeeAcc[];

  /** Employeedocuments */
  employeeDocuments: EmployeeDoc[];
}

export interface EmployeeAcc {
  /** Employeebankbik */
  employeeBankBik?: string;

  /** Employeebankcountry */
  employeeBankCountry?: string;

  /** Employeebankname */
  employeeBankName?: string;

  /** Employeeaccountcurrency */
  employeeAccountCurrency?: string;

  /** Employeeaccountnumber */
  employeeAccountNumber?: string;

  /** Employeebankcorrespondentaccount */
  employeeBankCorrespondentAccount?: string;

  /** Actuale */
  actuale?: boolean;
}

export interface EmployeeAccount {
  /** Employeebankbik */
  employeeBankBik: string;

  /** Employeebankname */
  employeeBankName: string;

  /** Employeeaccountcurrency */
  employeeAccountCurrency?: string;

  /** Employeeaccountnumber */
  employeeAccountNumber: string;

  /** Employeebankcorrespondentaccount */
  employeeBankCorrespondentAccount: string;
}

export interface EmployeeDoc {
  /** Documenttype */
  documentType?: string;

  /** Documenttypemvd */
  documentTypeMvd?: string;

  /** Documentseriesnumber */
  documentSeriesNumber?: string;

  /** Documentseries */
  documentSeries?: string;

  /** Documentnumber */
  documentNumber?: string;

  /** Documentdateofissue */
  documentDateOfIssue?: string;

  /** Documentvalidityperiod */
  documentValidityPeriod?: string;

  /** Documentissuedbywhom */
  documentIssuedByWhom?: string;

  /** Documentdivisioncode */
  documentDivisionCode?: string;

  /** Documentlastnameeng */
  documentLastNameEng?: string;

  /** Documentfirstnameeng */
  documentFirstNameEng?: string;

  /** Documentcountry */
  documentCountry?: string;

  /** Documentisanidentitydocument */
  documentIsAnIdentityDocument?: boolean;
}

export interface EmployeeDocument {
  /** Documenttype */
  documentType: string;

  /** Documenttypemvd */
  documentTypeMvd: string;

  /** Documentseriesnumber */
  documentSeriesNumber?: string;

  /** Documentisanidentitydocument */
  documentIsAnIdentityDocument: boolean;
}

export interface EmployeeSts {
  /** Employeeinn */
  employeeInn: string;

  /** Employeename */
  employeeName?: string;

  /** Employeelastname */
  employeeLastName: string;

  /** Employeefirstname */
  employeeFirstName: string;

  /** Employeepatronymic */
  employeePatronymic: string;

  /** Snils */
  snils: string;

  /** Birthday */
  birthday: string;

  /** Dismissal */
  dismissal?: string;

  /** Position */
  position?: string;

  /** Gender */
  gender: string;

  /** Citizenship */
  citizenship: string;

  /** Employeeaccounts */
  employeeAccounts: EmployeeAccount[];

  /** Employeedocuments */
  employeeDocuments: EmployeeDocument[];
}

export interface FnsNotification {
  /**
   * Messageid
   * Идентификатор сообщения
   */
  messageId: string;

  /**
   * Header
   * Заголовок
   */
  header: string;

  /**
   * Message
   * Сообщение
   */
  message: string;

  /**
   * Notificationstatus
   * Статус оповещения
   */
  notificationStatus: string;

  /**
   * Creationdatetime
   * Время создания оповещения
   */
  creationDateTime: string;
}

export interface Payment {
  /** Code */
  code?: string;

  /** Name */
  name?: string;

  /** Insurancefeecodes */
  insuranceFeeCodes?: boolean;

  /** Purpose */
  purpose?: string;

  /** Typeincomecode */
  typeIncomeCode?: number;

  /** Priority */
  priority?: number;

  /** Counttax */
  countTax?: boolean;

  /** Purposetax */
  purposeTax?: string;

  /** Availableretention */
  availableRetention?: boolean;

  /** Deductions */
  deductions: string[];
}

export interface Uninsured {
  /** Code */
  code?: string;

  /** Amount */
  amount?: number;
}

export interface UninsuredPayment {
  /** Code */
  code: string;

  /** Amount */
  amount: string;
}

export interface UninsuredPaymentsItem {
  /** Code */
  code?: string;

  /** Name */
  name?: string;

  /** Begindate */
  beginDate?: string;

  /** Enddate */
  endDate?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Проект 'Информационный обмен АУСН'
 * @version 3.7.135
 *
 * Мастер-система для взаимодействия с модулями 1С и ФНС
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description 8.1.2 Проверка списка сотрудников НП в модуле Сотрудники. Метод вызывает Банк для получения информации по уже существующим сотрудникам НП в модуле Сотрудники
     *
     * @tags 8. Отчеты по сотрудникам
     * @name GetEmployeesApiConnectorExternalV1GetemployeesGet
     * @summary Get Employees
     * @request GET:/api/connector/external/v1/getemployees
     */
    getEmployeesApiConnectorExternalV1GetemployeesGet: (
      query: { inn: string; ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<GetEmployees, HTTPValidationError>({
        path: `/api/connector/external/v1/getemployees`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 8.1.3 Запрос справочника стран с кодами
     *
     * @tags 8. Отчеты по сотрудникам
     * @name CountriesApiConnectorExternalV1CountriesGet
     * @summary Countries
     * @request GET:/api/connector/external/v1/countries
     */
    countriesApiConnectorExternalV1CountriesGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<GetCountries[], HTTPValidationError>({
        path: `/api/connector/external/v1/countries`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 8.1.4 Запрос справочника кодов доходов, выплат и вычетов
     *
     * @tags 8. Отчеты по сотрудникам
     * @name GetCodesApiConnectorExternalV1GetcodesGet
     * @summary Get Codes
     * @request GET:/api/connector/external/v1/getcodes
     */
    getCodesApiConnectorExternalV1GetcodesGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<GetCodes, HTTPValidationError>({
        path: `/api/connector/external/v1/getcodes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 8.1.5 Регистрация списка сотрудников НП
     *
     * @tags 8. Отчеты по сотрудникам
     * @name EmployeesApiConnectorExternalV1EmployeesPost
     * @summary Employees
     * @request POST:/api/connector/external/v1/employees
     */
    employeesApiConnectorExternalV1EmployeesPost: (
      data: EmployeesParser,
      params: RequestParams = {}
    ) =>
      this.request<string, HTTPValidationError>({
        path: `/api/connector/external/v1/employees`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 8.1.7 Отправка выплат по сотрудникам. Выплата должна быть фактически исполнена в АБС.
     *
     * @tags 8. Отчеты по сотрудникам
     * @name MovementsApiConnectorExternalV1MovementsPost
     * @summary Movements
     * @request POST:/api/connector/external/v1/movements
     */
    movementsApiConnectorExternalV1MovementsPost: (
      data: Movements,
      params: RequestParams = {}
    ) =>
      this.request<string, HTTPValidationError>({
        path: `/api/connector/external/v1/movements`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 8.1.10 Запрос истории выплат. Статус принятых в фнс
     *
     * @tags 8. Отчеты по сотрудникам
     * @name GetMovementsArchiveApiConnectorExternalV1GetmovementsarchiveGet
     * @summary Get Movements Archive
     * @request GET:/api/connector/external/v1/getmovementsarchive
     */
    getMovementsArchiveApiConnectorExternalV1GetmovementsarchiveGet: (
      query: { inn: string },
      params: RequestParams = {}
    ) =>
      this.request<GetMovementsArchive, HTTPValidationError>({
        path: `/api/connector/external/v1/getmovementsarchive`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение налоговой информации по клиенту
     *
     * @tags Фронт
     * @name GetTaxesApiConnectorExternalV1TaxesGet
     * @summary Get Taxes
     * @request GET:/api/connector/external/v1/taxes
     * @secure
     */
    getTaxesApiConnectorExternalV1TaxesGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<GetTaxesResponse, HTTPValidationError>({
        path: `/api/connector/external/v1/taxes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка оперций по клиенту
     *
     * @tags Фронт
     * @name GetOperationsApiConnectorExternalV1OperationsPost
     * @summary Get Operations
     * @request POST:/api/connector/external/v1/operations
     * @secure
     */
    getOperationsApiConnectorExternalV1OperationsPost: (
      data: GetOperationsRequest,
      params: RequestParams = {}
    ) =>
      this.request<GetOperationsResponse, HTTPValidationError>({
        path: `/api/connector/external/v1/operations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправка заявления АУСН
     *
     * @tags Фронт
     * @name SendApplicationApiConnectorExternalV1ApplicationPost
     * @summary Send Application
     * @request POST:/api/connector/external/v1/application
     * @secure
     */
    sendApplicationApiConnectorExternalV1ApplicationPost: (
      data: SendApplication,
      params: RequestParams = {}
    ) =>
      this.request<string, HTTPValidationError>({
        path: `/api/connector/external/v1/application`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновление разметки операции
     *
     * @tags Фронт
     * @name MarkupOperationApiConnectorExternalV1MarkupPut
     * @summary Markup Operation
     * @request PUT:/api/connector/external/v1/markup
     */
    markupOperationApiConnectorExternalV1MarkupPut: (
      data: MarkupOperationRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, HTTPValidationError>({
        path: `/api/connector/external/v1/markup`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение реквизитов на уплату взносов на ОСС
     *
     * @tags Фронт
     * @name GetOssRequisitesApiConnectorExternalV1OssrequisitesGet
     * @summary Get Oss Requisites
     * @request GET:/api/connector/external/v1/ossrequisites
     * @secure
     */
    getOssRequisitesApiConnectorExternalV1OssrequisitesGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<OSSRequisites, HTTPValidationError>({
        path: `/api/connector/external/v1/ossrequisites`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение информации о налогоплательщике АУСН
     *
     * @tags Фронт
     * @name GetAusnSettingsApiConnectorExternalV1AusnSettingsGet
     * @summary Get Ausn Settings
     * @request GET:/api/connector/external/v1/ausn-settings
     * @secure
     */
    getAusnSettingsApiConnectorExternalV1AusnSettingsGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AusnSettings, HTTPValidationError>({
        path: `/api/connector/external/v1/ausn-settings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка ранее поданных заявлений АУСН
     *
     * @tags Фронт
     * @name GetApplicationsApiConnectorExternalV1ApplicationsGet
     * @summary Get Applications
     * @request GET:/api/connector/external/v1/applications
     * @secure
     */
    getApplicationsApiConnectorExternalV1ApplicationsGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<ApplicationsGet, HTTPValidationError>({
        path: `/api/connector/external/v1/applications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка оповещений от ФНС
     *
     * @tags Фронт
     * @name GetNotificationsApiConnectorExternalV1NotificationsGet
     * @summary Get Notifications
     * @request GET:/api/connector/external/v1/notifications
     * @secure
     */
    getNotificationsApiConnectorExternalV1NotificationsGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<Notification, HTTPValidationError>({
        path: `/api/connector/external/v1/notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение от клиента согласия с офертой АУСН
     *
     * @tags Фронт
     * @name GetOfferApiConnectorExternalV1OfferGet
     * @summary Get Offer
     * @request GET:/api/connector/external/v1/offer
     * @secure
     */
    getOfferApiConnectorExternalV1OfferGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<Offer, HTTPValidationError>({
        path: `/api/connector/external/v1/offer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Фронт
     * @name GetOssAmountApiConnectorExternalV1OssAmountGet
     * @summary Get Oss Amount
     * @request GET:/api/connector/external/v1/oss-amount
     * @secure
     */
    getOssAmountApiConnectorExternalV1OssAmountGet: (
      query?: { ignore_extra?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<OssAmount, HTTPValidationError>({
        path: `/api/connector/external/v1/oss-amount`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Изменение статуса оповещения от ФНС
     *
     * @tags Фронт
     * @name NotificationStatus
     * @summary Notification Status
     * @request PUT:/api/connector/external/v1/notification-status
     * @secure
     */
    notificationStatus: (
      data: NotificationStatus,
      params: RequestParams = {}
    ) =>
      this.request<DefaultResponse, HTTPValidationError>({
        path: `/api/connector/external/v1/notification-status`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
